import React from 'react';
import { SmsIcon } from '../sms/SmsMarks';
import { RentalPurchaseOrder } from '../../types/models';
import { PurchaseRecoveryRecord } from '../../utils/purchaseRecovery';
import { formatUsd } from '../../utils/format';

interface PurchaseRecoveryCardProps {
  kindLabel: string;
  record: PurchaseRecoveryRecord;
  order: RentalPurchaseOrder | null;
  checking: boolean;
  onCheck: () => void;
  onDismiss: () => void;
}

const PurchaseRecoveryCard: React.FC<PurchaseRecoveryCardProps> = ({
  kindLabel,
  record,
  order,
  checking,
  onCheck,
  onDismiss,
}) => {
  const isManual = order?.state === 'manual_review';
  const isFinished = Boolean(order?.terminal && !order.recovery.required);
  const status = order?.recovery.label
    || (order?.state === 'active' ? 'Покупка завершена' : null)
    || (isFinished ? 'Заявка завершена' : 'Статус заявки уточняется');
  const paymentStatus = isManual
    ? 'Проверяется оператором'
    : order?.id
      ? 'Сумма зарезервирована; списание — только после выдачи номера'
      : 'Повторная проверка использует тот же ключ: двойного списания не будет';

  return (
    <section className={`sms-card sms-purchaseRecovery ${isManual ? 'is-manual' : ''}`} aria-labelledby="purchase-recovery-title">
      <div className="sms-purchaseRecovery__icon"><SmsIcon name={isManual ? 'headphones' : 'refresh'} /></div>
      <div className="sms-purchaseRecovery__body">
        <div className="sms-purchaseRecovery__head">
          <div>
            <h2 id="purchase-recovery-title">Незавершённая заявка · {kindLabel}</h2>
            <p>{status}</p>
          </div>
          <strong>{formatUsd(order?.amount ?? record.amount)}</strong>
        </div>
        <dl>
          <div><dt>ID заявки</dt><dd><code>{record.orderId || 'получаем…'}</code></dd></div>
          <div><dt>Оплата</dt><dd>{paymentStatus}</dd></div>
          {order?.updatedAt ? <div><dt>Обновлено</dt><dd>{new Date(order.updatedAt).toLocaleString('ru-RU')}</dd></div> : null}
        </dl>
        <div className="sms-purchaseRecovery__actions">
          {!isFinished && !isManual ? (
            <button type="button" className="u2-btn is-primary" onClick={onCheck} disabled={checking}>
              {checking ? 'Проверяем…' : 'Проверить статус'}
            </button>
          ) : null}
          {(isFinished || isManual) ? <button type="button" className="u2-btn is-secondary" onClick={onDismiss}>Скрыть</button> : null}
        </div>
      </div>
    </section>
  );
};

export default PurchaseRecoveryCard;
